import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { ClaimsAdminTool } from "./ClaimsAdminTool";
import React, { useState } from "react";
import { DownloadClaimsTool } from "./DownloadClaimsTool";
import { Button } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CreateClaimDialog from "./CreateClaimDialog";

export const ClaimManagmentAdminTool = () => {
  const [searchType, setSearchType] = React.useState("dealer");
  const [openCreateClaimDialog, setOpenCreateClaimDialog] = useState(false);

  const handleChange = (event) => {
    setSearchType(event.target.value);
  };

  return (
    <>
      <CreateClaimDialog
        open={openCreateClaimDialog}
        onClose={() => setOpenCreateClaimDialog(false)}
        dealer={null}
        tenant={null}
      />
      <FormControl sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', mb: 1 }}>
        <FormLabel id="cmat-radio-buttons-group-label" sx={{mr:1}}>
          Search Claim By
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="cmat-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={searchType}
          onChange={handleChange}
        >

          <FormControlLabel value="dealer" control={<Radio color="secondary"/>} label="Dealer" />
                    <FormControlLabel
            value="jobnumber"
            control={<Radio color="secondary" />}
            label="Job Number"

          />
        </RadioGroup>
        <Button
          variant="contained"
          color="success"
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setOpenCreateClaimDialog(true)}
        >
          New Claim
        </Button>
      </FormControl>
      {searchType === "jobnumber" ? (
        <ClaimsAdminTool />
      ) : (
        <DownloadClaimsTool />
      )}
    </>
  );
};
